/**
 * Selection Store
 * Manages multi-select state + box-select drag state for board tasks
 */

import { createStore } from '@xstate/store';

interface SelectionContext {
  selectedIds: string[];
  isBoxSelecting: boolean;
}

export const selectionStore = createStore({
  context: { selectedIds: [], isBoxSelecting: false } as SelectionContext,
  on: {
    'selection.selectOne': (ctx, event: { taskId: string }) => ({
      ...ctx,
      selectedIds: [event.taskId],
    }),
    'selection.toggle': (ctx, event: { taskId: string }) => {
      const has = ctx.selectedIds.includes(event.taskId);
      return {
        ...ctx,
        selectedIds: has
          ? ctx.selectedIds.filter(id => id !== event.taskId)
          : [...ctx.selectedIds, event.taskId],
      };
    },
    'selection.set': (ctx, event: { taskIds: string[] }) => ({
      ...ctx,
      selectedIds: event.taskIds,
    }),
    'selection.add': (ctx, event: { taskIds: string[] }) => {
      const existing = new Set(ctx.selectedIds);
      for (const id of event.taskIds) existing.add(id);
      return { ...ctx, selectedIds: [...existing] };
    },
    'selection.clear': (ctx) => {
      if (ctx.selectedIds.length === 0 && !ctx.isBoxSelecting) return ctx;
      return { ...ctx, selectedIds: [], isBoxSelecting: false };
    },
    'selection.prune': (ctx, event: { validIds: Set<string> }) => {
      const pruned = ctx.selectedIds.filter(id => event.validIds.has(id));
      if (pruned.length === ctx.selectedIds.length) return ctx;
      return { ...ctx, selectedIds: pruned };
    },
    'boxSelect.start': (ctx) => {
      if (ctx.isBoxSelecting) return ctx;
      return { ...ctx, isBoxSelecting: true };
    },
    'boxSelect.end': (ctx) => {
      if (!ctx.isBoxSelecting) return ctx;
      return { ...ctx, isBoxSelecting: false };
    },
  },
});
